module.exports = __webpack_public_path__ + "static/media/vmcare-dark.4125e781.svg";